export const config = {
  urls: {
    base: "https://awagjxgz1l.execute-api.eu-north-1.amazonaws.com/prod/barometers/",
  },
};
